import { render, staticRenderFns } from "./NSSIMenu.vue?vue&type=template&id=3bcdd0d3&"
import script from "./NSSIMenu.vue?vue&type=script&lang=js&"
export * from "./NSSIMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports